import { defineComponent as _defineComponent } from 'vue'
import CreatedInfo from '@/components/common/CreatedInfo.vue'
import { useSearchInvoicesQuery } from '@/api/invoice'
import { usePagination } from './pagination'
import { computed, reactive, ref } from 'vue'
import { useBuildSearchBatchesQuery } from '@/components/batches/query'
import moment from 'moment'
import { BatchPaymentTerms, batchPaymentTermsString } from '@/models/invoice'


export default /*#__PURE__*/_defineComponent({
  __name: 'BatchesList',
  props: {
    hubId: null
  },
  emits: ["select", "open-create-batch-form"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'select', batchId: string)
  (e: 'open-create-batch-form', initialBatchNumber: string)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  hubId?: string
}



const search = ref('')
const { currentPage, updatePage } = usePagination()
const hubIdRef = computed(() => props.hubId)
const query = reactive(useBuildSearchBatchesQuery(currentPage, 20, search))
const {
  invoices: batches,
  totalPages,
  isLoading,
  reFetch,
} = useSearchInvoicesQuery(query)



function formattedBatchCustomerText(
  clientName: string | null,
  hubName: string | null
) {
  if (clientName !== null && hubName !== null) {
    return `Customer: ${clientName} > ${hubName}`
  }
  return `Customer: Not selected yet`
}

function handleSelectBatch(selectedBatchId: string) {
  emit('select', selectedBatchId)
}

const refetchBatchesList = () => {
  reFetch()
}

const updateSearch = (newSearchKey: string) => {
  search.value = newSearchKey
}

const handleOpenCreateBatchForm = () => {
  emit('open-create-batch-form', search.value)
}

expose({ refetchBatchesList, updateSearch })

return { __sfc: true,props, search, currentPage, updatePage, hubIdRef, query, batches, totalPages, isLoading, reFetch, emit, formattedBatchCustomerText, handleSelectBatch, refetchBatchesList, updateSearch, handleOpenCreateBatchForm, CreatedInfo, moment, BatchPaymentTerms, batchPaymentTermsString }
}

})